import React from 'react';

function Help() {
    return (
        <div className="page-container">
            <p>If you need assistance using the app, feel free to contact us via the contact page or refer to our FAQs.</p>
        </div>
    );
}

export default Help;
